import { render, staticRenderFns } from "./LogoutButton.vue?vue&type=template&id=0019c9cc&scoped=true&"
import script from "./LogoutButton.vue?vue&type=script&lang=ts&"
export * from "./LogoutButton.vue?vue&type=script&lang=ts&"
import style0 from "./LogoutButton.vue?vue&type=style&index=0&id=0019c9cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0019c9cc",
  null
  
)

export default component.exports